import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserNotifications } from "../../redux/actions/action";
import bell from "../../assets/images/Bell.svg";
import { Image } from "react-bootstrap";
import { useHistory } from "react-router-dom";

const NotificationBell = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const userID = useMemo(() => window.localStorage.getItem("userid"), []);

  const userNotificationList = useSelector(
    (state) => state.user.userNotifications,
  );
  const [localList, setLocalList] = useState([]);

  useEffect(() => {
    if (userID) {
      dispatch(getUserNotifications(userID));
    }
  }, [dispatch, userID]);

  useEffect(() => {
    setLocalList(Array.isArray(userNotificationList) ? userNotificationList : []);
  }, [userNotificationList]);

  const unreadNotificationCount = useMemo(() => {
    return localList.filter((item) => isUnread(item)).length;
  }, [localList]);

  return (
    <div style={{ cursor: "pointer", position: "relative" }}>
      {unreadNotificationCount > 0 && (
        <NotificationDot count={unreadNotificationCount} />
      )}
      <Image
        width={20}
        height={24}
        src={bell}
        onClick={() => history.push("/notifications")}
      />
    </div>
  );
};

const NotificationDot = ({ count }) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "-7px",
        right: "-8px",
        backgroundColor: "#F76767",
        border: "1px solid #FFFFFF",
        borderRadius: "50%",
        minHeight: "18px",
        minWidth: "18px",
        color: "#fff",
        fontSize: "10px",
        fontWeight: 700,
        lineHeight: "16px",
        padding: "0 4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
      }}
    >
      {count > 99 ? "99+" : count}
    </div>
  );
};

const isUnread = (item) => {
  const seenValue = item?.isSeen ?? item?.IsSeen;
  if (typeof seenValue === "boolean") {
    return !seenValue;
  }
  if (typeof seenValue === "string") {
    return ["false", "0", "no", "n"].includes(seenValue.toLowerCase());
  }
  return !Boolean(seenValue);
};

export default NotificationBell;
